// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3bDvA","colMaxWidth":"Table_colMaxWidth__1VnBv"};